export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
    disabled: ({ amzFtyNoticeInStatus }) => amzFtyNoticeInStatus !== 'N',
  },
  {
    text: that.$l('menu_text_delete') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    disabled: ({ amzFtyNoticeInStatus }) => amzFtyNoticeInStatus !== 'N',
  },
  {
    text: that.$l('menu_text_send') || '通知送仓',
    icon: 'el-icon-message',
    menuType: 'send',
    divided: true,
    allow: 'S',
    data: {},
    disabled: ({ amzFtyNoticeInStatus }) => amzFtyNoticeInStatus !== 'N',
  },
  {
    text: that.$l('menu_text_confirm') || '送仓确认',
    icon: 'el-icon-chat-dot-square',
    menuType: 'confirm',
    divided: false,
    allow: 'F',
    data: {},
    disabled: ({ amzFtyNoticeInStatus }) => amzFtyNoticeInStatus !== 'S',
  },
  {
    text: that.$l('menu_text_cancel') || '取消入库',
    icon: 'el-icon-error',
    menuType: 'cancel',
    divided: false,
    allow: 'R',
    data: {},
    disabled: ({ amzFtyNoticeInStatus }) => {
      return !(amzFtyNoticeInStatus === 'S' || amzFtyNoticeInStatus === 'F')
    },
  },
  {
    text: that.$l('menu_text_adjust') || '数据调整',
    icon: 'el-icon-edit-outline',
    menuType: 'adjust',
    divided: false,
    allow: 'C',
    data: {},
    disabled: ({ amzFtyNoticeInStatus }) => {
      return !(amzFtyNoticeInStatus === 'S' || amzFtyNoticeInStatus === 'F')
    },
  },
  {
    text: that.$l('menu_text_printer') || '打印标签',
    icon: 'el-icon-printer',
    menuType: 'printer',
    divided: true,
    allow: 'P',
    disabled: ({ amzFtyNoticeInStatus }) => {
      return (
        amzFtyNoticeInStatus !== 'S' &&
        amzFtyNoticeInStatus !== 'F' &&
        amzFtyNoticeInStatus !== 'Y'
      )
    },
  },
  {
    text: that.$l('menu_text_export') || '导出单据',
    icon: 'el-icon-download',
    menuType: 'export',
    divided: false,
    allow: 'E',
    disabled: ({ amzFtyNoticeInStatus }) => {
      return (
        amzFtyNoticeInStatus !== 'S' &&
        amzFtyNoticeInStatus !== 'F' &&
        amzFtyNoticeInStatus !== 'Y'
      )
    },
  },
]
